export default {
  brandName: "Bura DEV",
  logoAlt: "{{brandName}} Logo",
  tagline:
    "Crafting digital experiences that bridge technology and creativity. Your success fuels our passion.",
  quickLinksTitle: "Quick Links",
  quickLinks: {
    home: "Home",
    javad: "About Javad",
    faranack: "About Faranack",
    contact: "Contact",
  },
  connectTitle: "Connect With Us",
  socialLabels: {
    email: "Email",
    website: "Website",
    github: "GitHub",
    telegram: "Telegram",
  },
  readyPrompt: "Ready to start your project?",
  copyright: "© {{year}} Bura DEV. All rights reserved.",
  builtWithPrefix: "Built with",
  builtWithSuffix: "and technology",
  scrollToTop: "Scroll to top",
};
